import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router'
import store from "@/store/store";
import { createI18n } from 'vue-i18n'


// 引入语言文件
import en from './locales/en_US.json'
import zh from './locales/zh_CN.json'
import TW from './locales/zh_TW.json'
import ko from './locales/ko_KR.json'
import ja from './locales/ja_JP.json'

import './assets/css/global.css'
import GoTop from "@/components/GoTop.vue";
import KanonBookingModal from "@/components/kanon/KanonBookingModal.vue";

// 函数防抖
const debounce = (fn, delay) => {
    let timer = null;
    return function () {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    }
}

// 优化ResizeObserver以提高性能
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
    constructor(callback) {
        callback = debounce(callback, 16);
        super(callback);
    }
}

// 尝试从localStorage获取用户语言偏好，如果未设置，则默认为简体中文
const savedLocale = sessionStorage.getItem('userLanguage') || 'zh_CN';

// 配置i18n
const i18n = createI18n({
    legacy: false, // 推荐对于Vue 3设置为false
    locale: savedLocale, // 使用保存的语言设置或默认语言
    fallbackLocale: 'zh_CN', // 设置回退语言为简体中文
    messages: {
        en_US: en,
        zh_CN: zh,
        zh_TW: TW,
        ko_KR: ko,
        ja_JP: ja,
    }
});

const app = createApp(App)
app.component('GoTop', GoTop);
app.component('KanonBookingModal', KanonBookingModal);
app.use(ElementPlus)
app.use(router)
app.use(i18n)
app.use(store)

app.mount('#app')
